<script>
import { SvgIcon, firebaseServices } from '@leapsight/styleguide'
import store from '@/store'
import firebaseTagNames from '@/constants/firebaseTagNames'

export default {
  name: 'MenuServicesAndProducts',
  components: { SvgIcon },
  props: {
    showInvoice: {
      type: Function,
      default: () => ({})
    },
    toggleHelpCenterBox: {
      type: Function,
      default: () => ({})
    },
    avatarImage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      logoutLoading: false,
      toggleHelpCenterWithAnalytics: () => {
        console.log('ENTRÓ EN CENTRO DE AYUDA');
        firebaseServices.logEvent(
          firebaseServices.analytics,
          firebaseTagNames.BTN_PORTAL_MENU_AND_SERVICES_HELP_CENTER
        )
        this.toggleHelpCenterBox()
      },
      subLinks: [
        {
          text: 'Mis facturas',
          icon: 'mdi-invoice-text-arrow-right-outline',
          fn: this.linkToInvoice,
          show: this.showInvoice
        },
        {
          text: 'Centro de ayuda',
          icon: 'icon_help_center',
          fn: () => this.toggleHelpCenterWithAnalytics(),
          show: () => true
        },
        {
          text: 'Mi perfil',
          icon: 'icon_user_settings',
          fn: this.linkToProfile,
          show: () => true
        }
      ]
    }
  },
  methods: {
    linkToProfile() {
      if (/^\/portal\.*/.test(this.$route.path))
        this.$router.push({ path: '/portal/user-settings' })
      else
        window.location.assign(`${window.location.origin}/portal/user-settings`)

      firebaseServices.logEvent(
        firebaseServices.analytics,
        firebaseTagNames.BTN_PORTAL_MENU_AND_SERVICES_MY_PROFILE
      )
    },
    linkToInvoice() {
      window.open(
        'https://misfacturas.strix.com.ar/Account/Login.aspx?ReturnUrl=%2f',
        '_black'
      )

      firebaseServices.logEvent(
        firebaseServices.analytics,
        firebaseTagNames.BTN_PORTAL_MENU_AND_SERVICES_MY_BILLS
      )
    },
    getInitials() {
      const { name, last_name: lastName } = JSON.parse(
        localStorage.getItem('user')
      )
      return (name ? name.charAt(0) : '') + (lastName ? lastName.charAt(0) : '')
    },
    logout() {
      this.logoutLoading = true
      store.dispatch('auth/logout').then(() => {
        this.logoutLoading = false
        const appName = this.$route.path.split('/')[1]
        switch (appName) {
          case 'fleet-management':
            window.location.assign(`${window.location.origin}/portal/login`)
            break
          case 'reports':
            window.location.assign(`${window.location.origin}/portal/login`)
            break
          case 'portal':
            this.$router.push({ name: 'login' })
            break
          default:
            break
        }
      })
    }
  }
}
</script>

<template>
  <v-menu offset-y rounded="lg">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-avatar v-if="avatarImage" size="35" id="idAvatar">
          <img :src="avatarImage" alt="Avatar" />
        </v-avatar>
        <v-avatar
          v-else
          color="primary"
          style="color: white"
          size="35"
          id="idAyudaAvatar"
          >{{ getInitials() }}
        </v-avatar>
      </v-btn>
    </template>
    <v-card>
      <v-list flat>
        <v-list-item>
          <v-list-item-title
            v-text="'Productos y servicios'"
          ></v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item-group>
          <v-list-item
            v-for="item of subLinks"
            :key="item.text"
            link
            v-show="item.show()"
            @click="item.fn()"
            :id="
              item.text === 'Centro de ayuda' ? 'idAyudaCentroDeAyuda' : null
            "
          >
            <v-list-item-icon class="mr-3">
              <v-icon
                class="secondary--text"
                v-if="
                  item.icon !== 'icon_user_settings' &&
                    item.icon !== 'icon_help_center'
                "
                v-text="item.icon"
              ></v-icon>
              <SvgIcon
                v-else-if="item.icon === 'icon_user_settings'"
                class="secondary--text"
                iconType="icon_user_settings"
              />
              <SvgIcon
                v-else-if="item.icon === 'icon_help_center'"
                class="secondary--text"
                iconType="icon_help_center"
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item link @click="logout">
          <v-list-item-icon class="mr-3">
            <SvgIcon class="secondary--text" iconType="icon_logout" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'Cerrar sesión'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<style scoped></style>
